/*
*
* File JS per la pagina singola di Applicazioni Soluzioni
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

// import heroBase from '../../components/hero-base/hero-base';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './appl-soluzioni-single.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

addEventListener('DOMContentLoaded', (evt) =>
{
    // heroBase();
});

//--------------------------------------------------------------------//